import type { ArticleContent } from './article';
import { pillarEn } from './pillarContent.en';
import { pillarPl } from './pillarContent.pl';
import { pillarEs } from './pillarContent.es';
import { pillarFr } from './pillarContent.fr';

export interface PillarMeta {
  slug: string;
  image: string;
  cardTitle: Record<string, string>;
  cardDesc: Record<string, string>;
}

export const pillarMetas: PillarMeta[] = [
  {
    slug: 'usfans-review',
    image:
      'https://readdy.ai/api/search-image?query=Minimal%20product%20review%20concept%20flat%20lay%20of%20sneaker%20and%20hoodie%20with%20rating%20stars%20and%20notes%20on%20clean%20cream%20background%20soft%20light%20editorial%20style%20high%20detail&width=640&height=480&seq=pillar-review-01&orientation=landscape',
    cardTitle: {
      en: 'USFans Review',
      pl: 'USFans Review',
      es: 'USFans Review',
      fr: 'USFans Review',
    },
    cardDesc: {
      en: 'A practical look at categories, the shopping experience and what to check before buying.',
      pl: 'Praktyczne spojrzenie na kategorie, doświadczenie zakupowe i co sprawdzić przed zakupem.',
      es: 'Una mirada práctica a las categorías, la experiencia de compra y qué revisar antes de comprar.',
      fr: 'Un regard pratique sur les catégories, l\'expérience d\'achat et ce qu\'il faut vérifier.',
    },
  },
  {
    slug: 'usfans-shipping',
    image:
      'https://readdy.ai/api/search-image?query=Cardboard%20shipping%20box%20with%20packing%20tape%20and%20a%20folded%20shirt%20on%20clean%20cream%20background%20soft%20natural%20light%20minimal%20editorial%20style%20high%20detail&width=640&height=480&seq=pillar-shipping-02&orientation=landscape',
    cardTitle: {
      en: 'USFans Shipping',
      pl: 'USFans Shipping',
      es: 'USFans Shipping',
      fr: 'USFans Shipping',
    },
    cardDesc: {
      en: 'Understand shipping methods, delivery times and how to track your order.',
      pl: 'Poznaj metody wysyłki, czasy dostawy i sposób śledzenia zamówienia.',
      es: 'Entiende los métodos de envío, los plazos y cómo rastrear tu pedido.',
      fr: 'Comprenez les méthodes de livraison, les délais et comment suivre votre commande.',
    },
  },
  {
    slug: 'usfans-shipping-cost',
    image:
      'https://readdy.ai/api/search-image?query=Flat%20lay%20of%20a%20receipt%20calculator%20and%20small%20package%20on%20clean%20cream%20background%20soft%20natural%20light%20minimal%20editorial%20style%20high%20detail&width=640&height=480&seq=pillar-shipcost-03&orientation=landscape',
    cardTitle: {
      en: 'USFans Shipping Cost',
      pl: 'Koszt wysyłki USFans',
      es: 'Coste de envío de USFans',
      fr: 'Frais de livraison USFans',
    },
    cardDesc: {
      en: 'Learn what affects shipping cost and how to plan your order budget.',
      pl: 'Dowiedz się, co wpływa na koszt wysyłki i jak planować budżet zamówienia.',
      es: 'Aprende qué afecta al coste de envío y cómo planificar tu presupuesto.',
      fr: 'Découvrez ce qui influence les frais et comment planifier votre budget.',
    },
  },
  {
    slug: 'usfans-coupon',
    image:
      'https://readdy.ai/api/search-image?query=Scissors%20and%20coupon%20ticket%20with%20discount%20tag%20on%20clean%20cream%20background%20soft%20natural%20light%20minimal%20editorial%20style%20high%20detail&width=640&height=480&seq=pillar-coupon-04&orientation=landscape',
    cardTitle: {
      en: 'USFans Coupon',
      pl: 'USFans Coupon',
      es: 'USFans Coupon',
      fr: 'USFans Coupon',
    },
    cardDesc: {
      en: 'Find and use USFans coupons correctly to save on your next order.',
      pl: 'Znajduj i używaj kuponów USFans poprawnie, aby zaoszczędzić.',
      es: 'Encuentra y usa los cupones de USFans para ahorrar en tu pedido.',
      fr: 'Trouvez et utilisez les coupons USFans correctement pour économiser.',
    },
  },
  {
    slug: 'usfans-discount-code',
    image:
      'https://readdy.ai/api/search-image?query=Gift%20card%20and%20promo%20code%20on%20a%20smartphone%20screen%20with%20shopping%20bag%20on%20clean%20cream%20background%20soft%20natural%20light%20minimal%20editorial%20style%20high%20detail&width=640&height=480&seq=pillar-discount-05&orientation=landscape',
    cardTitle: {
      en: 'USFans Discount Code',
      pl: 'USFans Discount Code',
      es: 'USFans Discount Code',
      fr: 'USFans Discount Code',
    },
    cardDesc: {
      en: 'How discount codes work, where to find them and how to apply them.',
      pl: 'Jak działają kody rabatowe, gdzie je znaleźć i jak je zastosować.',
      es: 'Cómo funcionan los códigos, dónde encontrarlos y cómo aplicarlos.',
      fr: 'Comment fonctionnent les codes, où les trouver et comment les appliquer.',
    },
  },
  {
    slug: 'usfans-warehouse',
    image:
      'https://readdy.ai/api/search-image?query=Warehouse%20shelves%20with%20neatly%20stacked%20cardboard%20boxes%20and%20packages%20on%20clean%20cream%20background%20soft%20natural%20light%20minimal%20editorial%20style%20high%20detail&width=640&height=480&seq=pillar-warehouse-06&orientation=landscape',
    cardTitle: {
      en: 'USFans Warehouse',
      pl: 'USFans Warehouse',
      es: 'USFans Warehouse',
      fr: 'USFans Warehouse',
    },
    cardDesc: {
      en: 'Understand how storage, quality checks and shipping preparation work.',
      pl: 'Zrozum, jak działa magazynowanie, kontrola jakości i przygotowanie do wysyłki.',
      es: 'Entiende cómo funcionan el almacenamiento, el control de calidad y la preparación.',
      fr: 'Comprenez comment fonctionnent le stockage, le contrôle qualité et la préparation.',
    },
  },
  {
    slug: 'usfans-legit',
    image:
      'https://readdy.ai/api/search-image?query=Shield%20checkmark%20icon%20with%20verified%20badge%20and%20lock%20symbol%20on%20clean%20cream%20background%20soft%20natural%20light%20minimal%20editorial%20style%20high%20detail&width=640&height=480&seq=pillar-legit-07&orientation=landscape',
    cardTitle: {
      en: 'Is USFans Legit?',
      pl: 'Czy USFans jest legalny?',
      es: '¿USFans es legítimo?',
      fr: 'USFans est-il légitime ?',
    },
    cardDesc: {
      en: 'A balanced look at safety and trust, with steps to verify the site.',
      pl: 'Zrównoważone spojrzenie na bezpieczeństwo i zaufanie oraz kroki weryfikacji.',
      es: 'Una mirada equilibrada a la seguridad y la confianza, con pasos para verificar.',
      fr: 'Un regard équilibré sur la sécurité et la confiance, avec des étapes de vérification.',
    },
  },
  {
    slug: 'usfans-safety',
    image:
      'https://readdy.ai/api/search-image?query=Padlock%20and%20credit%20card%20with%20secure%20shopping%20concept%20on%20clean%20cream%20background%20soft%20natural%20light%20minimal%20editorial%20style%20high%20detail&width=640&height=480&seq=pillar-safety-08&orientation=landscape',
    cardTitle: {
      en: 'USFans Safety',
      pl: 'USFans Safety',
      es: 'USFans Safety',
      fr: 'USFans Safety',
    },
    cardDesc: {
      en: 'Practical tips to protect your account, payments and personal data.',
      pl: 'Praktyczne wskazówki ochrony konta, płatności i danych osobowych.',
      es: 'Consejos prácticos para proteger tu cuenta, pagos y datos personales.',
      fr: 'Conseils pratiques pour protéger votre compte, vos paiements et vos données.',
    },
  },
  {
    slug: 'usfans-qc',
    image:
      'https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20a%20folded%20garment%20with%20checklist%20and%20quality%20control%20concept%20on%20clean%20cream%20background%20soft%20natural%20light%20minimal%20editorial%20style%20high%20detail&width=640&height=480&seq=pillar-qc-09&orientation=landscape',
    cardTitle: {
      en: 'USFans QC Guide',
      pl: 'USFans QC Guide',
      es: 'USFans QC Guide',
      fr: 'USFans QC Guide',
    },
    cardDesc: {
      en: 'Understand quality control, what checks involve and how they help.',
      pl: 'Zrozum kontrolę jakości, co obejmuje i jak pomaga.',
      es: 'Entiende el control de calidad, qué implica y cómo ayuda.',
      fr: 'Comprenez le contrôle qualité, ce qu\'il implique et comment il aide.',
    },
  },
  {
    slug: 'usfans-shopping-guide',
    image:
      'https://readdy.ai/api/search-image?query=Online%20shopping%20concept%20with%20shopping%20cart%20bags%20and%20folded%20clothing%20on%20clean%20cream%20background%20soft%20natural%20light%20minimal%20editorial%20style%20high%20detail&width=640&height=480&seq=pillar-shopping-10&orientation=landscape',
    cardTitle: {
      en: 'USFans Shopping Guide',
      pl: 'USFans Shopping Guide',
      es: 'USFans Shopping Guide',
      fr: 'USFans Shopping Guide',
    },
    cardDesc: {
      en: 'Shop smarter from start to finish with categories, comparison and safety.',
      pl: 'Rób zakupy mądrzej od początku do końca z kategoriami i bezpieczeństwem.',
      es: 'Compra mejor de principio a fin con categorías, comparación y seguridad.',
      fr: 'Achetez mieux de A à Z avec les catégories, la comparaison et la sécurité.',
    },
  },
];

const contentMap: Record<string, Record<string, ArticleContent>> = {
  en: pillarEn,
  pl: pillarPl,
  es: pillarEs,
  fr: pillarFr,
};

export const pillarContent: Record<string, Record<string, ArticleContent>> = {};

pillarMetas.forEach((meta) => {
  pillarContent[meta.slug] = {
    en: contentMap.en[meta.slug],
    pl: contentMap.pl[meta.slug],
    es: contentMap.es[meta.slug],
    fr: contentMap.fr[meta.slug],
  };
});